var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiltericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 18.9596C15.4913 18.9596 15.208 18.6763 15.208 18.3346V9.16797C15.208 8.8263 15.4913 8.54297 15.833 8.54297C16.1747 8.54297 16.458 8.8263 16.458 9.16797V18.3346C16.458 18.6763 16.1747 18.9596 15.833 18.9596Z",
    fill: "#798AA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 6.45964C15.4913 6.45964 15.208 6.1763 15.208 5.83464V1.66797C15.208 1.3263 15.4913 1.04297 15.833 1.04297C16.1747 1.04297 16.458 1.3263 16.458 1.66797V5.83464C16.458 6.1763 16.1747 6.45964 15.833 6.45964Z",
    fill: "#798AA5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.9596C9.65833 18.9596 9.375 18.6763 9.375 18.3346V14.168C9.375 13.8263 9.65833 13.543 10 13.543C10.3417 13.543 10.625 13.8263 10.625 14.168V18.3346C10.625 18.6763 10.3417 18.9596 10 18.9596Z",
    fill: "#798AA5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.4596C9.65833 11.4596 9.375 11.1763 9.375 10.8346V1.66797C9.375 1.3263 9.65833 1.04297 10 1.04297C10.3417 1.04297 10.625 1.3263 10.625 1.66797V10.8346C10.625 11.1763 10.3417 11.4596 10 11.4596Z",
    fill: "#798AA5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 18.9596C3.82533 18.9596 3.54199 18.6763 3.54199 18.3346V9.16797C3.54199 8.8263 3.82533 8.54297 4.16699 8.54297C4.50866 8.54297 4.79199 8.8263 4.79199 9.16797V18.3346C4.79199 18.6763 4.50866 18.9596 4.16699 18.9596Z",
    fill: "#798AA5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 6.45964C3.82533 6.45964 3.54199 6.1763 3.54199 5.83464V1.66797C3.54199 1.3263 3.82533 1.04297 4.16699 1.04297C4.50866 1.04297 4.79199 1.3263 4.79199 1.66797V5.83464C4.79199 6.1763 4.50866 6.45964 4.16699 6.45964Z",
    fill: "#798AA5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 9.79297H2.5C2.15833 9.79297 1.875 9.50964 1.875 9.16797C1.875 8.8263 2.15833 8.54297 2.5 8.54297H5.83333C6.175 8.54297 6.45833 8.8263 6.45833 9.16797C6.45833 9.50964 6.175 9.79297 5.83333 9.79297Z",
    fill: "#798AA5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5003 9.79297H14.167C13.8253 9.79297 13.542 9.50964 13.542 9.16797C13.542 8.8263 13.8253 8.54297 14.167 8.54297H17.5003C17.842 8.54297 18.1253 8.8263 18.1253 9.16797C18.1253 9.50964 17.842 9.79297 17.5003 9.79297Z",
    fill: "#798AA5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6663 11.457H8.33301C7.99134 11.457 7.70801 11.1737 7.70801 10.832C7.70801 10.4904 7.99134 10.207 8.33301 10.207H11.6663C12.008 10.207 12.2913 10.4904 12.2913 10.832C12.2913 11.1737 12.008 11.457 11.6663 11.457Z",
    fill: "#798AA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltericon);
export default __webpack_public_path__ + "static/media/filtericon.66cbd2e79106924716d31e726069387c.svg";
export { ForwardRef as ReactComponent };